import React, { memo, useState } from 'react'
import { pick } from 'lodash-es'
import { showNotification } from '@mantine/notifications'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import { createSharedLink } from '@vt/apis/lib-ex/v2/share'
import ShareDetailModal from './detailModal'

const SharePopup = ({ objectId, onLoading, children }) => {
  const [shareDetail, setShareDetail] = useState(null)

  const { appId } = useAppEx()
  const { tbId, id, selectedIds } = useTbViewStore((state) =>
    pick(state, ['tbId', 'id', 'selectedIds'])
  )

  const onClickShare = () => {
    if (onLoading) onLoading(true)

    createSharedLink({
      sharedSourceType: objectId ? 'SINGLE_UCASE' : 'UCASE_LIST',
      appId,
      tbId,
      viewId: id,
      objectId,
      queryDsl:
        !objectId && selectedIds.length
          ? {
              logicType: 'and',
              queries: [
                {
                  slug: 'objectId',
                  queryType: 'inList',
                  value: selectedIds,
                },
              ],
            }
          : {},
    })
      .then((res) => {
        setShareDetail(res)
      })
      .catch((err) => {
        console.log(err)
        showNotification({
          title: '提示',
          message: '分享失败',
        })
      })
      .finally(() => {
        if (onLoading) onLoading(false)
      })
  }

  return (
    <>
      <div onClick={onClickShare}>{children}</div>
      {shareDetail && (
        <ShareDetailModal
          detail={shareDetail}
          open={!!shareDetail}
          onClose={() => setShareDetail(null)}
        />
      )}
    </>
  )
}

export default memo(SharePopup)
